// File: /src/lib/axios.ts
// Created Date: Monday September 16th 2024
// Author: Christian Nonis <alch.infoemail@gmail.com>
// -----
// Last Modified: Monday September 16th 2024 5:57:24 pm
// Modified By: the developer formerly known as Christian Nonis at <alch.infoemail@gmail.com>
// -----

import axios from "axios";
import { reportError } from "./errorReporting";

export const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

client.interceptors.response.use(
  (response) => response,
  (error) => {
    const requestUrl = String(error?.config?.url ?? "unknown").split("?")[0];
    if (!requestUrl.includes("/errors/client")) {
      void reportError(error, {
        operation: `api.${String(error?.config?.method ?? "request").toLowerCase()}`,
        metadata: {
          endpoint: requestUrl,
          status: error?.response?.status,
          requestId: error?.response?.headers?.["x-request-id"],
        },
      });
    }
    return Promise.reject(error);
  }
);
